import React from 'react';
import { IconButton, InputAdornment } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { themeColor } from '../../../mui-theme';

const InputCancelAdornment = ({
  name,
  state,
  resetState,
}: IInputCancelAdornmentProps): JSX.Element => {
  return (
    <InputAdornment position='end'>
      <IconButton
        aria-label={`clear ${name} input`}
        onClick={(e): void => {
          resetState();
          e.preventDefault();
        }}
      >
        {state && <ClearIcon htmlColor={themeColor.infoMain} />}
      </IconButton>
    </InputAdornment>
  );
};

interface IInputCancelAdornmentProps {
  name: string;
  state: string;
  resetState: () => void;
}
export default InputCancelAdornment;
